import { observer } from 'mobx-react';
import { makeObservable, observable, action } from 'mobx';
import { Component } from 'react';

import { PromiseCompletion } from '../classes/PromiseCompletion';
import apiService from '../services/apiService';

import ImgGoogle from '../components/Images/ImgGoogle';
import { ImgUnlock } from '../components/Images/ImgUnlock';
import { ImgLock } from '../components/Images/ImgLock';
import { AccessCodeEntry } from '../components/AccessCodeEntry';

@observer
class LoginPage extends Component {
  @observable private _username: string = '';
  @observable private _password: string = '';
  @observable private _errorMessage: string = '';
  private _loader: PromiseCompletion = new PromiseCompletion();

  constructor(props: {}) {
    super(props);
    makeObservable(this);
  }

  componentDidMount() {
    document.getElementsByClassName('ui-loader-container')[0]?.remove();
  }

  render() {
    return (
      <div className="login-container">
        <div className="login-box">
          <div className="login-header">
            <h1><ImgLock /> FileVault</h1>
            <p>Secure file storage</p>
          </div>
          <form>
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                className="form-control"
                placeholder="Enter username"
                required
                name="username"
                value={this._username}
                onChange={(e) => this._username = e.target.value}
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                className="form-control"
                placeholder="Enter password"
                required
                value={this._password}
                onChange={(e) => this._password = e.target.value}
              />
            </div>
            <button className="btn btn-primary" onClick={this._onSignInClick}><ImgUnlock /> Sign In</button>
            {this._errorMessage && <div className="error-message">{this._errorMessage}</div>}
          </form>
          <div className="divider">or</div>
          <button className="btn btn-google" onClick={this._onGoogleLoginClick}>
            <ImgGoogle /> Continue with Google
          </button>
          <div className="divider">or</div>
          <div>
            <p style={{ margin: '0 0 8px', fontSize: '13px', fontWeight: 500, textAlign: 'center' }}>Access a shared file</p>
            <AccessCodeEntry />
          </div>
        </div>
      </div>
    );
  }

  @action.bound
  private async _onSignInClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    
    //call POST /login/simple with username and password, after successful login check redirect to home page
    const payload = {
      username: this._username,
      password: this._password
    };

    const authResult = await apiService.post<{ success: boolean }>('/login/simple', payload, {
      loader: this._loader,
      allowUnauthenticated: true,
      checkStatusCode: false
    });

    if (authResult.success) {
      window.location.href = '/';
    } else {
      this._errorMessage = 'Invalid username or password';
    }
  }

  @action.bound
  private _onGoogleLoginClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    // Handle Google login logic here
  }
}

export default LoginPage;